import { AfterContentInit, ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatLegacyColumnDef as MatColumnDef } from '@angular/material/legacy-table';

import { ColumnInfo, TemplateColumnKeys } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';

import { ReportTableColumnTemplateComponent } from './rt-column-template.component';

@Component({
  selector: 'mg-archive-column',
  styles: ["[class*='w-'] {flex: initial; min-width: 0 !important }"],
  template: `<ng-container matColumnDef="{{ datasource.TEMPLATE_KEYS.ARCHIVE }}">
    <mat-header-cell
      *matHeaderCellDef
      [mat-sort-header]="datasource.TEMPLATE_KEYS.ARCHIVE"
      [disabled]="true"
      [ngClass]="archiveColumn.columnClasses">
    </mat-header-cell>
    <mat-cell
      *matCellDef="let item; let i = index"
      class="button-container"
      [ngClass]="archiveColumn.columnClasses">
      <mg-btn
        variant="icon"
        icon="mg-archive"
        iconSet="minga"
        tooltip="Archive"
        (pressed)="datasource.archiveItem(item, i)">
      </mg-btn>
    </mat-cell>
  </ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: ReportTableColumnTemplateComponent,
      useExisting: ReportTableArchiveTemplateComponent,
    },
  ],
})
export class ReportTableArchiveTemplateComponent implements AfterContentInit {
  @ViewChild(MatColumnDef, { static: true }) columnDef: MatColumnDef;

  archiveColumn: ColumnInfo;

  @Input()
  datasource: ReportDatasourceService<any>;

  constructor() {}

  ngAfterContentInit(): void {
    this.archiveColumn = this.datasource.getTemplateColumns().find(col => col.key === TemplateColumnKeys.ARCHIVE);
  }
}
